import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface CourseAdminLinkState {
  courseAdminLink: string;
}

const courseAdminLink: Module<CourseAdminLinkState, RootState> = {
  namespaced: true,
  state: {
    courseAdminLink: '',
  },
  mutations: {
    setValue(state: CourseAdminLinkState, value: string): void {
      state.courseAdminLink = value;
    },
  },
};

export default courseAdminLink;
